import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../layouts/AdminLayout";
import AdminBillingPricingPlanTab from "../../components/admin/billing/AdminBillingPricingPlanTab";
import AdminBillingHistory from "../../components/admin/billing/AdminBillingHistory";
import AdminBillingDetails from "../../components/admin/billing/AdminBillingDetails";
import Spinner from "../../components/common/Spinner";
import { decryptData } from "../../utils/encryptDecrypt";
import api, { fetchData } from "../../api/api";
import { CONSTANT_CURRENCY, CONSTANT_REDIRECT_TIME } from "../../constant/common";
import { AuthContext } from "../../context/AuthContext";
import {
	useElements,
	useStripe,
	CardNumberElement,
	CardExpiryElement,
	CardCvcElement,
} from '@stripe/react-stripe-js';
import { toast } from "react-toastify";
import { height } from "@mui/system";

const getCardOptions = () => {
	const isMobile = window.innerWidth < 640;

	return {
		style: {
			base: {
				fontSize: "1.25rem",
				height: isMobile ? "48px" : "56px",
				lineHeight: isMobile ? "48px" : "56px",
				display: "flex",
				alignItems: "center",
				"::placeholder": {
					color: "#aab7c4",
				},
			},
			invalid: {
				color: "red",
			},
		},
	};
};


const AdminPaymentPage = () => {

	const stripe = useStripe();
	const elements = useElements();
	const [isSubmitting, setIsSubmitting] = useState(false);

	const { pricing_plan_id } = useParams();

	const decrypted_pricing_plan_id = decryptData(pricing_plan_id);

	const navigate = useNavigate();

	const { user, setUser } = useContext(AuthContext);

	const didFetch = useRef(false);

	const [isLoading, setIsLoading] = useState(false);

	const [princingPlanDetail, setPrincingPlanDetail] = useState([]);

	const [cardsList, setCardsList] = useState([]);

	const [selectedCardId, setSelectedCardId] = useState(null);

	const [isDelete, setIsDelete] = useState(false);
	const [isDeleteCardId, setIsDeleteCardId] = useState(null);

	const getprincingPlanDetail = async () => {
		if (decrypted_pricing_plan_id) {
			setIsLoading(true);
			try {
				const data = await fetchData('/details-pricing-plan', { pricing_plan_id: decrypted_pricing_plan_id, status: 1 });
				setPrincingPlanDetail(data);
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	const getCards = async () => {
		if (user?.users_id) {
			setIsLoading(true);
			try {
				const data = await fetchData('/get-cards', { fk_users_id: user?.users_id, status: 1 });
				setCardsList(data);
			} catch (error) {
				console.error("Error fetching data:", error);
			} finally {
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		if (!didFetch.current) {
			getprincingPlanDetail();
			getCards();
			didFetch.current = true;
		}
	}, []);

	const [formData, setFormData] = useState({
		fk_users_id: user?.users_id,
		fk_pricing_plan_id: decrypted_pricing_plan_id,
		card_holder_name: ""
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const [cardComplete, setCardComplete] = useState(false);
	const [expiryComplete, setExpiryComplete] = useState(false);
	const [cvcComplete, setCvcComplete] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) return;

		const { card_holder_name } = formData;


		let payload = {};

		if (!selectedCardId) {

			if (!card_holder_name.trim()) {
				toast.error("Please enter card holder name");
				return;
			}

			if (!cardComplete || !expiryComplete || !cvcComplete) {
				toast.error("Please complete all card fields");
				return;
			}

			setIsSubmitting(true);
			const cardElement = elements.getElement(CardNumberElement);

			const { paymentMethod, error } = await stripe.createPaymentMethod({
				type: "card",
				card: cardElement,
				billing_details: {
					name: formData.card_holder_name,
				},
			});

			if (error) {
				console.error(error);

				toast.error(error.message || "Failed payment");

				setIsSubmitting(false);
				return;
			}

			payload = {
				stripe_response: JSON.stringify(paymentMethod),
				pricing_plan_id: decrypted_pricing_plan_id
			}
		}
		else {
			payload = {
				cards_id: selectedCardId,
				pricing_plan_id: decrypted_pricing_plan_id
			}
		}

		try {
			setIsSubmitting(true);

			const response = await api.post("add-orders", payload, {
				headers: { "Content-Type": "application/json" },
			});

			setIsSubmitting(false);

			if (response?.data?.status === true) {
				toast.success(response.data?.message);

				setUser(response.data?.data?.user);

				// setTimeout(() => {
				// 	getCards();

				// 	setFormData((prev) => ({
				// 		...prev,
				// 		card_holder_name: "",
				// 	}));

				// 	setSelectedCardId(null)

				// }, CONSTANT_REDIRECT_TIME);

				setTimeout(() => {
					navigate(`/admin/billing`)
				}, CONSTANT_REDIRECT_TIME);

			}
			else {
				setIsSubmitting(false);
				console.log(response)

				toast.error(response?.data?.message || "Failed payment");
				return null;
			}

		} catch (error) {
			setIsSubmitting(false);

			console.error("Error :", error?.response?.data?.message);
			const errorMsg = error?.response?.data?.message ? error?.response?.data?.message : "Something went wrong. Please try again."
			toast.error(errorMsg);
			return null;
		}
	}


	const handleDeleteCard = async () => {
		const payload = {
			cards_id: isDeleteCardId
		};
		try {
			const response = await api.post("delete-cards", payload);

			if (response?.data?.status === true) {
				toast.success(response.data?.message);

				setTimeout(() => {
					getCards();
				}, CONSTANT_REDIRECT_TIME);

			} else {
				toast.error(response?.data?.message || "Failed to delete card.");
				return null;
			}
		} catch (error) {
			console.error("Error delete card:", error);
			toast.error("Something went wrong. Please try again.");
			return null;
		}
		setIsDeleteCardId(null);
		setIsDelete(false);
	}

	if (isLoading) {
		return (<Spinner adminLayout={true} />);
	}

	return (
		<>
			<AdminLayout>
				<div className="bg-[#EDF4FF]">

					<main>
						<div className="container mx-auto px-3">
							<div className="px-4 py-4 sm:px-8 sm:py-6 md:px-12 md:py-7 flex justify-center gap-4 items-center">
								<h1 className="font-semibold text-[28px] leading-normal text-center text-dark">Payment</h1>
							</div>
							<div className="grid grid-cols-12 gap-[30px] pb-10">
								<div className="col-span-12 lg:col-span-7 p-6 bg-white rounded-[18px]">
									<h1 className="items-center font-semibold text-[28px] leading-normal text-dark mb-6">Payment Details</h1>
									<h2 className="flex felx-wrap items-center font-semibold text-2xl text-dark mb-10">Pay by Credit Card
										<img src="/assets/image/visamastercard.png" alt="" srcset="" className="ml-3" />
									</h2>
									<div className="space-y-4">
										{cardsList?.length > 0 && cardsList?.map((card, index) => (
											<div key={index}
												className="flex items-center justify-between border rounded-xl p-4 shadow-md flex-wrap gap-2"
											>
												<div className="flex items-center space-x-4 cursor-pointer"
													onClick={() => {
														if (selectedCardId === card?.cards_id) {
															setSelectedCardId(null)
														}
														else {
															setSelectedCardId(card.cards_id)
														}
													}}>
													<input type="radio"
														id="visa-card"
														className="w-5 h-5 text-blue-600 focus:ring-blue-500"
														checked={!selectedCardId ? false : (selectedCardId === card.cards_id ? true : false)}
													/>
													<div>
														<p className="text-lg font-semibold text-dark">
															{card?.card_brand?.charAt(0).toUpperCase() + card?.card_brand?.slice(1)}
															{' '}ending in{' '} {card?.last_4}
														</p>
														<p className="text-gray-500 text-sm">Expiry {card?.exp_month}/{card?.exp_year}</p>
													</div>
												</div>
												{card?.card_brand != "unknown" &&
													<div className="flex items-center space-x-4">
														<img src={`/assets/image/cards/${card?.card_brand}.png`} alt="Visa Logo" className="w-auto max-h-10 object-contain" />
													</div>
												}
												<div className="flex space-x-4  w-full pl-8">
													<button className="text-blue-600 hover:underline" type="button"
														onClick={() => {
															setIsDelete(true);
															setIsDeleteCardId(card?.cards_id);
														}}
													>Delete</button>
													{/* <button className="text-blue-600 hover:underline">Edit</button> */}
												</div>
											</div>
										))}


									</div>
									{cardsList?.length > 0 &&
										<div className="py-8 ">
											<hr />
											<span className="block text-center -mt-4">
												<span className="bg-white px-3 py-2 font-semibold text-lg text-dark">or</span>
											</span>

										</div>
									}
									<form onSubmit={handleSubmit} className="grid grid-cols-2 gap-5">
										<div className="col-span-2">
											<label htmlFor="card_holder_name" className="mb-2 inline-block text-dark font-semibold text-xl">Name on Card</label>
											<input value={formData.card_holder_name} onChange={handleChange} type="text" name="card_holder_name" id="card_holder_name" className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl" placeholder="John Smith" />
										</div>
										<div className="col-span-2">
											<label htmlFor="card_number" className="mb-2 inline-block text-dark font-semibold text-xl">Card Number</label>
											<div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
												<CardNumberElement
													options={getCardOptions()}
													onChange={(e) => setCardComplete(e.complete)}
													disableLink
												/>
											</div>
										</div>
										<div className="col-span-2 sm:col-span-1">
											<label htmlFor="card_expiry_date" className="mb-2 inline-block text-dark font-semibold text-xl">Expiry Date</label>
											<div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
												<CardExpiryElement
													options={getCardOptions()}
													onChange={(e) => setExpiryComplete(e.complete)}
												/>
											</div>
										</div>
										<div className="col-span-2 sm:col-span-1">
											<label htmlFor="card_cvv" className="mb-2 inline-block text-dark font-semibold text-xl">CVC</label>
											<div className="border-[1.2px] border-dark w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl">
												<CardCvcElement
													options={getCardOptions()}
													onChange={(e) => setCvcComplete(e.complete)}
												/>
											</div>
										</div>
										{/* <div className="col-span-2 ">
											<button type="submit"
												className={`h-auto block py-3 px-3 sm:h-14 w-full text-center font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px] 
    												${isSubmitting ? "bg-gray-400 cursor-not-allowed text-white" : "bg-blue text-white"}`}
												disabled={isSubmitting}>
												{isSubmitting ? "Processing..." : "Pay Now"}
											</button>
										</div> */}
										<div className="col-span-2 ">
											<div className="flex gap-3 w-full">

												<Link to={'/admin/billing'} className="h-auto sm:h-14 py-3 bg-lightblue px-4 sm:px-8 text-center text-blue font-medium text-lg sm:text-xl  rounded-xl flex items-center justify-center gap-3">
													<svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[18px]"><path d="M10 20L11.75 18.25L4.75 11.25L25 11.25V8.75L4.75 8.75L11.75 1.75L10 0L0 10L10 20Z" fill="#0052cc"></path></svg> <span className="hidden sm:block">Back</span>
												</Link>

												<button type="submit"
													className={`h-auto block py-3 px-3 sm:h-14 w-full text-center font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px] 
    												${isSubmitting ? "bg-gray-400 cursor-not-allowed text-white" : "bg-blue text-white"}`}
													disabled={isSubmitting}>
													{isSubmitting ? "Processing..." : "Pay Now"}
												</button>

											</div>
										</div>
									</form>
								</div>
								<div className="col-span-12 lg:col-span-5 ">
									<div className="p-6 bg-white rounded-[18px] sticky top-[100px]">
										<div className="border border-black rounded-2xl px-4 py-5">
											<div className="grid grid-cols-12 gap-1.5">
												<div className="col-span-7">
													<h2 className="text-dark font-bold text-[28px] leading-normal">{princingPlanDetail?.name}</h2>
												</div>
												<div className="col-span-5">
													<p className="text-end text-dark font-bold text-[28px] leading-normal">{CONSTANT_CURRENCY}{princingPlanDetail?.price}</p>
												</div>
												<div className="col-span-12 pb-6">
													<hr className="border-dark " />
												</div>
												<div className="col-span-7">
													<h2 className="text-dark font-bold text-[22px] leading-normal">G.S.T</h2>
												</div>
												<div className="col-span-5">
													<p className="text-end text-dark font-bold text-[22px] leading-normal">$0</p>
												</div>
												<div className="col-span-12 ">
													<hr className="border-[#C7C7C7]" />
												</div>
												<div className="col-span-7 pt-6">
													<h2 className="text-green font-bold text-[22px] leading-normal">Grand Total</h2>
												</div>
												<div className="col-span-5 pt-6">
													<p className="text-end text-green font-bold text-[22px] leading-normal">{CONSTANT_CURRENCY}{princingPlanDetail?.price}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</main>
				</div>


				<div id="deletepopup" className={`fixed bg-[#0000007A] top-0 left-0 h-screen w-full z-[999] justify-center items-center px-3 ${isDelete ? 'flex' : 'hidden'}`}>
					<div className="max-w-[630px] w-full mx-auto bg-white rounded-xl sm:rounded-2xl px-3 py-6 sm:py-10 sm:px-10 lg:px-20 innercard">
						<div className="max-w-[312px] w-full flex justify-center items-center gap-6 flex-col mx-auto">
							<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M36 66C19.4314 66 6 52.5684 6 36C6 19.4314 19.4314 6 36 6C52.5684 6 66 19.4314 66 36C66 52.5684 52.5684 66 36 66ZM36 60C49.2549 60 60 49.2549 60 36C60 22.7452 49.2549 12 36 12C22.7452 12 12 22.7452 12 36C12 49.2549 22.7452 60 36 60ZM36 31.7574L44.4852 23.2721L48.7278 27.5147L40.2426 36L48.7278 44.4852L44.4852 48.7278L36 40.2426L27.5147 48.7278L23.2721 44.4852L31.7574 36L23.2721 27.5147L27.5147 23.2721L36 31.7574Z" fill="#FF5252" />
							</svg>

							<h4 className="text-center font-bold text-xl mg:text-2xl text-blue">Are you sure! <br />you want to Delete?</h4>
							<div className="flex justify-between gap-3 w-full">
								<button
									type="button"
									onClick={() => {
										setIsDelete(false)
										setIsDeleteCardId(null)
									}}
									className="bg-transparent text-center text-dark text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-dark cancelbtn">Cancel</button>
								<button
									type="button"
									onClick={handleDeleteCard}
									className="bg-blue text-center text-white text-sm sm:text-base font-semibold sm:w-full sm:max-w-[154px] rounded-lg py-2 px-3 sm:py-3 sm:px-0 flex items-center justify-center border border-blue deletebtn">Delete</button>
							</div>
						</div>
					</div>
				</div>
			</AdminLayout>
		</>)
}

export default AdminPaymentPage